import { Grid } from '@mui/material';
import { PercentageBarGridline } from '../percentage-bar-gridline/percentage-bar-gridline.component';
import { usePercentageBarRowStyles } from './percentage-bar-row.styles';
import { SVGIconComponent } from '../../../icons/types';

export function PercentageBarRow({
  icon: { alt, Icon },
  color,
  count,
  percentage
}: {
  icon: {
    Icon?: SVGIconComponent;
    alt: string;
  };
  color?: string;
  percentage: number;
  count: { value: number; total: number; label: string };
}) {
  const classes = usePercentageBarRowStyles({ color });

  return (
    <Grid
      className={classes.root}
      container
      spacing={2}
      sx={{
        alignItems: 'center'
      }}
    >
      <Grid>{Icon ? <Icon className={classes.image} color={color} /> : <>{alt}</>}</Grid>
      <Grid size="grow">
        <Grid container sx={{ flexDirection: 'column' }}>
          <Grid className={classes.barWrapper}>
            <PercentageBarGridline color={color} percentage={percentage} />
          </Grid>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'flex-end'
            }}
          >
            <Grid>
              <p className={classes.percentageText}>{(percentage * 100).toFixed(0)}%</p>
            </Grid>
            <Grid>
              <p className={classes.countText}>
                {count.value} of {count.total} {count.label}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
